/**
 * Brilinton cart summary disclosure.
 * R44-296: the cart drawer owns one disclosure contract at every drawer width.
 * No 600/750 breakpoint is allowed to force the summary permanently open.
 */
(function () {
  function isDisclosureMode(button) {
    return Boolean(button && button.closest && button.closest('cart-drawer'));
  }

  function getSummary(button) {
    if (!button) return null;
    var summaryId = button.getAttribute('aria-controls');
    return summaryId ? document.getElementById(summaryId) : null;
  }

  function setSummaryState(button, expanded) {
    var summary = getSummary(button);
    if (!button || !summary) return;

    if (!isDisclosureMode(button)) {
      if (button.getAttribute('aria-expanded') !== 'true') button.setAttribute('aria-expanded', 'true');
      button.classList.remove('is-expanded');
      summary.hidden = false;
      summary.classList.add('is-expanded');
      return;
    }

    var nextValue = expanded ? 'true' : 'false';
    if (button.getAttribute('aria-expanded') !== nextValue) button.setAttribute('aria-expanded', nextValue);
    button.classList.toggle('is-expanded', expanded);
    summary.hidden = !expanded;
    summary.classList.toggle('is-expanded', expanded);
  }

  function syncAll() {
    document.querySelectorAll('.cart-summary-toggle').forEach(function (button) {
      setSummaryState(button, button.getAttribute('aria-expanded') === 'true');
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('.cart-summary-toggle');
    if (!button) return;
    event.preventDefault();
    if (!isDisclosureMode(button)) return;
    setSummaryState(button, button.getAttribute('aria-expanded') !== 'true');
  });

  window.BrilintonCartSummary = window.BrilintonCartSummary || {};
  window.BrilintonCartSummary.syncAll = syncAll;

  document.addEventListener('DOMContentLoaded', syncAll);
  window.addEventListener('brilinton:layout-refresh', syncAll);
})();
